export const userPackExpiresSeconds = 600; // 10 minutes
export const awsPackImagePrefix = 'packs-collections/';
export const awsPackImagePrefixCompressed = 'webp/h300/';
export const awsPackImagePrefixCompressedRect = 'webp/w1040/';
export const awsPackImageExtensionCompressed = 'webp';